// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Lng","right":"styles_right__2cDk7"};